import { apiClient } from "../config";

async function downloadReports(id: any,versionId:any) {
  const res = await apiClient.get(`/admin/reports/${id}/download-result/${versionId}`)
  return res.data;
}

export default downloadReports;
